export default __webpack_public_path__ + "static/media/ipad.20ed512c.svg";